import {Component, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {RequestHistoricalData} from '../../../generated/model/request-historical-data';
import {HistoryService} from '../../../services/history.service';
import {HistoricalDataLogFilter} from '../../../models/filter/historical-data-log-filter';
import {formatDate} from '@angular/common';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-historical-data-request-log',
  templateUrl: './historical-data-request-log.component.html',
  styleUrls: ['./historical-data-request-log.component.scss']
})
export class HistoricalDataRequestLogComponent implements OnInit {
  @ViewChild('dt') dataTable: any;
  historicalDataRequests: RequestHistoricalData[];
  filteredHistoricalDataRequests: RequestHistoricalData[];
  error = false;
  errorMessage = '';
  cols = [
    {field: 'formattedSentAt', sortField: 'sentAt', header: 'Sent Date', sortable: true},
    {field: 'path', header: 'Path', sortable: false},
    {field: 'formattedAvailable', header: 'Available', sortable: false},
    {field: 'period', header: 'Period', sortable: false},
    {field: 'userName', header: 'User Name', sortable: false},
    {field: 'email', header: 'Email', sortable: false},
    {field: 'companyName', header: 'Company Name', sortable: true}
  ];
  historicalDataLogFilter: HistoricalDataLogFilter;
  historicalDataLogFilterDefaults: HistoricalDataLogFilter = {
    company: null,
    dateFrom: null,
    dateTo: null
  };

  constructor(private historyService: HistoryService, private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.utilsService.lockUi();
    this.getHistoricalData();
  }

  private getHistoricalData() {
    this.historicalDataLogFilter = new HistoricalDataLogFilter(this.historicalDataLogFilterDefaults);
    this.historyService.getAllHistoricalData().pipe(map(
      (data: RequestHistoricalData[]) => {
        data.map(historyData => {
          if (historyData.sentAt) {
            historyData.formattedSentAt = formatDate(historyData.sentAt, 'yyyy/M/d H:mm', 'en-us');
          } else {
            historyData.formattedSentAt = '';
          }
          historyData.formattedAvailable = historyData.available === true ? 'Yes' : 'No';
          return historyData;
        });
        return data.sort((x, y) => +new Date(y.sentAt) - +new Date(x.sentAt));
      }
    )).subscribe({
        next: res => {
          this.historicalDataRequests = res;
          this.filteredHistoricalDataRequests = res;
          this.utilsService.unlockUi();
          this.initFilter();
        }, error: error => {
          this.error = true;
          this.errorMessage = error.message;
        }
      }
    );
  }

  private initFilter() {
    this.historicalDataLogFilter = new HistoricalDataLogFilter(
      this.utilsService.loadUserPref('historicalDataLogFilter', this.historicalDataLogFilterDefaults));
    this.filter();
  }

  get records() {
    return this.filteredHistoricalDataRequests ? this.filteredHistoricalDataRequests.length : 0;
  }

  resetTable() {
    this.historicalDataLogFilter = new HistoricalDataLogFilter(this.historicalDataLogFilterDefaults);
    this.filter();
  }

  get csvFilename() {
    return 'Historical-data-request-log';
  }

  filter() {
    this.filteredHistoricalDataRequests = this.historicalDataRequests;
    this.resetDataWithToDate();
    this.resetDataWithFromDate();
    this.resetDataWithCompany();
    this.utilsService.saveUserData('historicalDataLogFilter',
      {
        company: this.historicalDataLogFilter.company,
        dateFrom: this.historicalDataLogFilter.dateFrom,
        dateTo: this.historicalDataLogFilter.dateTo,
      });
    this.dataTable.reset();
  }

  resetDataWithFromDate() {
    if (!this.historicalDataLogFilter.dateFrom) {
      return;
    }
    this.filteredHistoricalDataRequests =
      this.filteredHistoricalDataRequests.filter(historyRequest => new Date(historyRequest.sentAt) >= this.historicalDataLogFilter.dateFrom);
  }

  resetDataWithToDate() {
    if (!this.historicalDataLogFilter.dateTo) {
      return;
    }
    const dateTo = this.historicalDataLogFilter.dateTo;
    const firstDayOfNextMonth = new Date(dateTo.getFullYear(), dateTo.getMonth() + 1, 1);
    this.filteredHistoricalDataRequests =
      this.filteredHistoricalDataRequests.filter(historyRequest => new Date(historyRequest.sentAt) < firstDayOfNextMonth);
  }

  private resetDataWithCompany() {
    if (!this.historicalDataLogFilter.company || this.historicalDataLogFilter.company === '') {
      return;
    }
    this.filteredHistoricalDataRequests = this.filteredHistoricalDataRequests.filter(historyRequest =>
      historyRequest.companyName.toLowerCase().includes(this.historicalDataLogFilter.company.toLocaleLowerCase()));
  }
}
